//#region Libraries
import styled from "styled-components";
import ScheduleActivityCard from "views/components/Schedules/components/ScheduleActivityCard/ScheduleActivityCard";
//#endregion

const ResourceScheduleActivityCard = styled(ScheduleActivityCard)`
    /*Aquí va el CSS específico para solo las cards base de las grilla de todos los submódulos de "Recursos"*/
    &.manual {
        & > header span {
            margin-top: 5px;
        }
        :not(.past) {
            background-color: var(--light-gray-4);
            & > header {
                h5, span {
                    color: var(--light-1);
                }
            }
            &.finalized {
                background-color: var(--light-1);
                border: 1px solid var(--light-gray-4);
                & > header * {
                    color: var(--light-gray-4);
                }
                .icon path, .info-icon path {
                    fill: var(--light-gray-4);
                }
            }
        }
    }
    &.past {
        .icon, .info-icon {
            path {
                fill: var(--light-gray-3);
            }
        }
    }
`;

export default ResourceScheduleActivityCard;